/*
 * Copyright (c) GeoMobile GmbH, 2022
 */
import { Status } from '../status/Status';
export var defaultAuthState = {
    isLoggedIn: false,
    username: '',
    token: '',
    status: Status.READY,
    errorMessage: null,
};
